/**
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function getContainOffsets(sw, sh, dw, dh) {
    const currentAspect = sw / sh;
    const endAspect = dw / dh;
    if (endAspect > currentAspect) {
        const newSh = sw / endAspect;
        const newSy = (sh - newSh) / 2;
        return { sw, sh: newSh, sx: 0, sy: newSy };
    }
    const newSw = sh * endAspect;
    const newSx = (sw - newSw) / 2;
    return { sh, sw: newSw, sx: newSx, sy: 0 };
}
